import { render } from "./HomeStats.vue?vue&type=template&id=e81c20b4&scoped=true"
import script from "./HomeStats.vue?vue&type=script&lang=js"
export * from "./HomeStats.vue?vue&type=script&lang=js"

import "./HomeStats.vue?vue&type=style&index=0&id=e81c20b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e81c20b4"]])

export default __exports__